import { IFavoritesActions, IFavoritesActionTypes, IFavoriteItem } from '../actions/favorites';
import { favoritesStorage } from '../utils/favoritesStorage';

// Load initial state from localStorage
const loadInitialState = () => {
  const storedItems = favoritesStorage.load();
  return {
    items: storedItems,
  };
};

const initialFavouritesTabs = loadInitialState();

export type IFavouritesTabs = typeof initialFavouritesTabs;

export function favouritesTabsReducer(state = initialFavouritesTabs, action: IFavoritesActions): IFavouritesTabs {
  let newState: IFavouritesTabs;
  
  switch (action.type) {
    case IFavoritesActionTypes.ADD_FAVORITE: {
      const favorite = action.payload;
      const { moduleId } = favorite;
      
      newState = {
        ...state,
        items: {
          ...state.items,
          [moduleId]: favorite,
        },
      };
      
      // Save to localStorage
      favoritesStorage.save(newState.items);
      return newState;
    }
    
    case IFavoritesActionTypes.REMOVE_FAVORITE: {
      const moduleId = action.payload;
      const favorite = state.items[moduleId];
      
      if (!favorite) {
        return state;
      }
      
      // Remove from items
      const { [moduleId]: removed, ...restItems } = state.items;
      
      newState = {
        ...state,
        items: restItems,
      };
      
      // Save to localStorage
      favoritesStorage.save(newState.items);
      return newState;
    }
    
    case IFavoritesActionTypes.CLEAR_FAVORITES: {
      newState = {
        items: {},
      };
      
      // Clear from localStorage
      favoritesStorage.clear();
      return newState;
    }
    
    case IFavoritesActionTypes.CLEANUP_FAVORITES: {
      const validModuleIds = action.payload;
      const validModuleIdsSet = new Set(validModuleIds);
      
      // Filter out favorites that are no longer in permissions
      const cleanedItems: typeof state.items = {};
      let hasChanges = false;
      
      Object.entries(state.items).forEach(([moduleId, favorite]) => {
        if (validModuleIdsSet.has(moduleId)) {
          cleanedItems[moduleId] = favorite;
        } else {
          hasChanges = true;
        }
      });
      
      // Only update if there were changes
      if (hasChanges) {
        newState = {
          ...state,
          items: cleanedItems,
        };
        
        // Save cleaned favorites to localStorage
        favoritesStorage.save(cleanedItems);
        return newState;
      }
      
      return state;
    }
    
    default:
      return state;
  }
}